import React, { useCallback, useRef, useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import * as Yup from "yup";
import { useFormik } from "formik";
import TextInput from "../../common/textfield/TextInput";
import SelectFiled from "../../common/textfield/SelectFiled";
import { useNavigate } from "react-router-dom";
import { Button } from "../../common/Button";
import { failed, success } from "../../common/Toastify";
import { decryptData, encryptData } from "../../EncryptDecrypt";
import {
  typeOptions,
  createAccountOptions,
  FormikObjCreate,
  relationsList,
  createBasicFieldsAPI
} from "./Constants";
import { useOrgQuery } from "../../../hooks/ReactQueryHooks/useOrgQuery";
import MultiSelect from "../../common/textfield/MultiSelect";
import { Skeleton, Tooltip } from "@mui/material";
import {
  createKioskDevice,
  createUser,
  getCustomRoles,
  getPractitionerData,
  getPractitionerList,
  updateAgentId,
} from "../../api/Individual";
import FilterSelect from "../../common/textfield/FilterSelect";
import { useClinicLocationsQuery } from "../../../hooks/ReactQueryHooks/useClinicLocationsQuery";
import { Clear } from "@mui/icons-material";
import moment from "moment";
import {
  createContactNumber,
  formattedPhoneNumberLength,
} from "../../../utils/phoneNumberSupport";
import { useSelector } from "react-redux";
import Fields from "./Fields";
import { getDiscover, getOrganization } from "../../api/Organization";
import { validation, conditionalValidation } from "../../../utils/constants";

function CreateApiAccount() {
  const navigate = useNavigate();
  const onSuccessLocations = (data) => {
    setLocations(
      data?.map((location) => (location = { ...location, value: location?.id }))
    );
  };
  useClinicLocationsQuery({ onSuccess: onSuccessLocations });
  const [locations, setLocations] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [organizations, setOrganizations] = useState([]);
  const [organizationsData, setOrganizationsData] = useState([]);
  const [rolesOptions, setRolesOptions] = useState([{ name: "-----" }]);
  //For Setting scope of jurisdictions
  const [regionOptions, setRegionOptions] = useState([]);
  //For selecting role and showing jurisdictions
  const [roleSelected, setRoleSelected] = useState(false);
  //For selecting org and showing roles  of that org
  const [orgSelected, setOrgSelected] = useState(false);

  const [typeStatus, setTypeStatus] = useState(true);
  const [createAccount, setCreateAccount] = useState(false);
  const [createAccountValue, setCreateAccountValue] = useState(true);
  const user = useSelector((state) => state?.auth?.user);
  const isCTIEnabledRef = useRef();

  //For getting general Practiotioner data and setting the list and options
  // const [generalPractitionerOptions, setGeneralPractitionerOptions] = useState(
  //   []
  // );
  // const [generalPractitionerData, setGeneralPractitionerData] = useState([]);
  const adminOrgs = useSelector((state) => state?.auth?.user?.organizations)

  //Fetching Organization Data
  const onSuccessOrg = (data) => {
    setOrganizations(data?.map((org) => (org = { ...org, value: org?.id })));
    setOrganizationsData(data);
  };



  const { isLoading } = useOrgQuery({ onSuccess: onSuccessOrg });

  //Handle change function for org selection and showing roles w.r.to selected org
  const handleOrgChange = async (event) => {
    const value = event?.target?.value;
    setOrgSelected(true);
    formik.setFieldValue("organization", value);
    
    await setCTIstatus(value);
  };

  const setCTIstatus = async(orgId) => {
    //const response = await getDiscover(orgId);
    const response = await getOrganization(orgId)
    isCTIEnabledRef.current = response?.data?.ctiSettings?.enabled;
  }
  //Handle change function for role selection and showing scope of jurisdiction w.r.to selected role
//   const handleRoleChange = (event) => {
//     const value = event?.target?.value;
//     formik.setFieldValue("role", value);
//     const roleType = rolesOptions.filter((role) => role?.id === value);
//     //If type clinical then show scope of jurisdiction
//     if (
//       roleType[0]?.type === "Clinical" ||
//       roleType[0]?.type === "Administrative_Clinical"
//     ) {
//       setRoleSelected(true);
//     } else {
//       formik.setFieldValue("countrylist", "");
//       formik.setFieldValue("jurisdiction", []);
//       setRoleSelected(false);
//     }
//   };


  const formik = useFormik({
    ...FormikObjCreate,
      initialValues: {
        ...FormikObjCreate.initialValues,
        type:  "API",
        create_account: true
      },
      validationSchema: Yup.object({
        account_name: conditionalValidation(
          Yup.string()
          .max(50, "Must be 50 characters or less")
          .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
          {
            validation,
            mandatory: true,
            label: "Account name"
          }),
        client_code: conditionalValidation(
          Yup.string()
          .max(50, "Must be 10 characters or less")
          .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
          {
            validation,
            mandatory: true,
            label: "Client Code"
          }),
        // phone_number: Yup.string().matches(
        //   /^(?:\+?1[-. ]?)?\(?[0-9]\d{2}\)?[-. ]?\d{3}[-. ]?\d{4}$/,
        //   "Enter Valid Phone Number."
        // ),
      
        // home_phone_number: Yup.string().matches(
        //   /^(?:\+?1[-. ]?)?\(?[0-9]\d{2}\)?[-. ]?\d{3}[-. ]?\d{4}$/,
        //   "Enter Valid Home Phone Number."
        // ),
      
        // ext: Yup.string().matches(/^\d{0,4}$/, "Must be 4 digits or less."),
      
        // address: Yup.string()
        //   .required("Required address field")
        //   .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
      
        // city: Yup.string()
        //   .required("Required city field")
        //   .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
      
        email: conditionalValidation(
          Yup.string().when("create_account", (type, schema) =>
            createAccountValue
              ? schema
                  .email("Invalid email address")
                  .matches(/^$|^\S+.*/, "Only blankspaces is not valid.")
              : schema.email("Invalid email address")),
              {
                validation,
                mandatory: true,
                label: "Email address"
              }
        ),
      
        type: conditionalValidation(
          Yup.string()
            .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
            {
              validation,
              label: "Type",
              mandatory: true
            }),
      
        organization: conditionalValidation(
          Yup.string()
            .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
            {
              validation,
              label: "Organization",
              mandatory: true
            }),
        // gender: Yup.string()
        //   .required("Required gender field")
        //   .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
      
        // country: Yup.string()
        //   .required("Required country field")
        //   .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
      
        // region: Yup.string()
        //   .required(`Required field`)
        //   .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
      
        role: conditionalValidation(
          Yup.string().when("type", (type, schema) =>
          typeStatus ? schema.required("Required Role field") : schema),
          {
            validation,
            mandatory: typeStatus,
            label: "Role"
          }
        ),
      
        create_account: conditionalValidation(
          Yup.string().when("type", (type, schema) =>
          createAccount ? schema.required("Required Create Account field") : schema),
          {
            validation,
            mandatory: createAccount,
            label: "Create Account"
          }
        ),
        agentId: conditionalValidation(
          Yup.string().matches(/^\S+$/,"Agent Id cannot contain any whitespace"),
          {
            validation,
            label: "Agent Id"
          }),
        // countrylist: Yup.string().when("role", (role, schema) =>
        //   role && roleSelected ? schema.required("Required Country field") : schema
        // ),
      
        // jurisdiction: Yup.array().when("role", (role, schema) =>
        //   role && roleSelected
        //     ? schema
        //         .min(1, "Required Jurisdictions field")
        //         .required("Required Jurisdictions field")
        //     : schema
        // ),  
        // postalCode: Yup.string().when(["type", "country"], (type, country, schema) =>
        //   country === "US"
        //     ? Yup.number()
        //         .typeError("Zip code must be a number")
        //         .required("Required field")
        //     : Yup.string()
        //         .required("Required field")
        //         .matches(
        //           /^[A-Za-z]\d[A-Za-z] [0-9][A-Za-z]\d$/,
        //           "Postal code must be in A1A 1A1 format."
        //         )
        // ), 
        // hcn: Yup.string().when("type", (type, schema) =>
        //   type === "Patient"
        //     ? schema.required("HCN is required when creating a patient.")
        //     : schema
        // ),
      }), 
    onSubmit: (values) => {
      const type = rolesOptions.filter((role) => role?.id === values.role);
      // const state = values?.region;
      // const generalPractitionersSelected = generalPractitionerData.filter((data) => values?.general_practitioner.includes(data?.id));
      // let phoneNumber = createContactNumber(values);
      let encryptedData = {
        account_name: encryptData(values?.account_name.toLowerCase()),
        // last_name: encryptData(values?.last_name.toLowerCase()),
        full_name: encryptData(
          [
            values?.account_name.toLowerCase(),
            // values?.last_name.toLowerCase(),
          ].join(" ")
        ),
        role: values?.role,
        type: encryptData(values?.type.toLowerCase()),
        // address: encryptData(values?.address),
        // date_of_birth: encryptData(moment(values?.date_of_birth).format("MM-DD-YYYY")),
        // phone_number: encryptData(phoneNumber),
        // postalCode: encryptData(values?.postalCode.toUpperCase()),
        // city: encryptData(values?.city),
        //gender: encryptData(values?.gender),
        email: encryptData(values?.email?.toLowerCase()),
        client_code: encryptData(values?.client_code),
        // relationship: encryptData(values?.relationship),
        // healthCardNumber: encryptData(values?.hcn),
        // device_name: encryptData(values?.device_name),
      };
      
      setBtnLoading(true);
      const selectedLocationData =
        locations?.filter(
          (location) => location?.id === values?.clinic_location
        )?.[0] || null;
      createUser(
        values,
        encryptedData,
        organizationsData,
        null,
        type,
        [],
        selectedLocationData,
        values.organization//adminOrgs?.[0]?.id
      )
        .then(async (res) => {
          if (res.status === true) {
            console.log("res", res?.data);
            if (values?.agentId){
              const practitionerLink = res?.data?.link[0]?.target?.reference
              const [, practitionerId] = practitionerLink.split("/");
              updateAgentId(practitionerId, values?.agentId)
                .then((res) => {
                  if (res.status === true) {
                    success("Agent ID added successfully");
                  } else {
                    failed("Failed to add Agent ID to practitioner record");
                  }
                })
                .catch((error) => {
                  console.error("Error updating Agent ID:", error);
                });
            }
            navigate("/app/identities/api-accounts");
            success(res.message);
          } else {
            failed(res.error);
          }
        })
        .catch((res) => {
          failed(
            res?.response?.data?.message ||
            res?.response?.data?.error ||
            res.message
          );
        })
        .finally(() => setBtnLoading(false));
    },
  });
  
  const handleFormChange = (e) => {
    if (e?.target?.id === "region" || e?.target?.id === "organization") {
      const selected_region =
        e?.target?.id === "region" ? e?.target?.value : formik?.values?.region;
      const selected_org =
        e?.target?.id === "organization"
          ? e?.target?.value
          : formik?.values?.organization;
    } else if (e?.target?.id === "country") {
      formik.setFieldValue("region", "");
      formik.setFieldValue("postalCode", "");
    }
  };

  useEffect(() => {
    getCustomRoles(["000000"])
      .then((res) => {
        formik.setFieldValue("role", res.data.filter(role => role.code == "apiAccount")[0].id);
        setRolesOptions(
          res?.data?.map(
            (role) => (role = { ...role, name: role?.display, value: role?.id })
          )
        );
      })
      .catch((res) => {
        failed(
          res?.response?.data?.message ||
          res?.response?.data?.error ||
          res.message
        );
      });
    
  }, [])

  return (
    <section className="common-listing">
      <div className="heading-wrap mb-3">
        {/* <Tooltip title="Go back">
          <div
            style={{ marginRight: "1rem", cursor: "pointer" }}
            onClick={() => navigate(-1)}
          >
            <ArrowBack />
          </div>
        </Tooltip> */}
      </div>
      <div className="custom-card p-4">
        <form
          className="common-form border-fields userAccount"
          onSubmit={formik.handleSubmit}
          onChange={handleFormChange}
        >
          <Row>
            {isLoading ? (
              <Col>
                <Skeleton animation="wave" />
              </Col>
            ) : (
              <Col md={3}>
                {formik?.values?.type !== "Super-Admin" ? (
                  <SelectFiled
                    keyField={"organization"}
                    label={"Select Organization"}
                    formik={formik}
                    options={organizations}
                    onChange={handleOrgChange}
                  />
                ) : null}
              </Col>
            )}
            <Col></Col>
            {/* { createAccount ? (
              <>
                <Col>
                  <SelectFiled
                    keyField={"create_account"}
                    label={"Create Account"}
                    formik={formik}
                    placeholder={"Create Account"}
                    options={createAccountOptions}
                    onChange={handleCreateAccountChange}
                  />
                </Col>
                
              </>
            ) : (
              <>
                <Col></Col>
                <Col></Col>
              </>
            )} */}
            <Col style={{display:"flex", placeContent: "flex-end"}}>
                  <Tooltip style={{}}>
                    <div
                      style={{ marginRight: "1rem", cursor: "pointer",maxHeight: "24px" }}
                      onClick={() => navigate(-1)}
                    >
                      <Clear />
                    </div>
                  </Tooltip>
            </Col>
          </Row>
        
          <Fields fields={createBasicFieldsAPI} formik={formik} isReadOnly={false}  />
          
          {/* {formik?.values?.type === "Patient" && formik?.values?.region ? (
            <Row>
              <Col>
                <MultiSelect
                  options={generalPractitionerOptions}
                  keyField={"general_practitioner"}
                  formik={formik}
                  label={"Assign Practitioner"}
                  nodata={"No Data Found"}
                  required={false}
                />
              </Col>
              <Col></Col>
              <Col></Col>
            </Row>
          ) : null} */}
          {/* {formik?.values?.type === "Patient" && (
            <Row>
              <Col>
                <TextInput
                  keyField={"hcn"}
                  label={"HCN"}
                  formik={formik}
                  placeholder={"HCN"}
                  required={true}
                />
              </Col>
              <Col></Col>
              <Col></Col>
            </Row>
          )} */}

          <div className="btn-wrap" style={{ display: "flex", gap: "16px" }}>
            <Button type="submit" isLoading={btnLoading}>
              Create
            </Button>
            <Button
              onClick={() => navigate("/app/identities/api-accounts")}
              variant="secondary"
            >
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </section>
  );
}

export default CreateApiAccount;
